import React from 'react';
import PropTypes from 'prop-types';
import { Table as MUITable, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@material-ui/core';

import { InputSearch } from 'components/Common';
import DatasetPresenter from 'presenters/DatasetPresenter';
import DocumentPresenter from 'presenters/DocumentPresenter';
import TemplatePresenter from 'presenters/TemplatePresenter';

import useStyles from './useStyles';

const Table = (props) => {
  const { rows, columns, tableCellClassName, title, onSearch } = props;
  const classes = useStyles();

  const renderRow = (row) => {
    return Object.keys(row).map((item, index) => (
      <TableCell
        key={index}
        className={classes[tableCellClassName]}
        align="left"
        dangerouslySetInnerHTML={{ __html: row[item] }}
      />
    ));
  };

  return (
    <TableContainer component={Paper} elevation={3}>
      <MUITable className={classes.table} aria-label="table">
        <TableHead>
          <TableRow className={classes.header}>
            <TableCell className={classes[tableCellClassName]} colSpan={5}>
              <div className={classes.headerInner}>
                <div className={classes.title}>{title}</div>
                <InputSearch onSearch={onSearch} />
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            {columns.map((column, index) => (
              <TableCell key={`th-${index}`} align="left">
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>{renderRow(row)}</TableRow>
          ))}
        </TableBody>
      </MUITable>
    </TableContainer>
  );
};

Table.propTypes = {
  rows: PropTypes.oneOfType([
    PropTypes.arrayOf(DatasetPresenter.shape()),
    PropTypes.arrayOf(DocumentPresenter.shape()),
    PropTypes.arrayOf(TemplatePresenter.shape()),
  ]),
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  tableCellClassName: PropTypes.string,
  title: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
};

Table.defaultProps = {
  rows: [],
  tableCellClassName: 'datasets',
  title: 'Import Datasets',
};

export default Table;
